<template>
    <div class="row">

        <div class="col-sm-12 mt-4 mb-2">
            <h5>{{title}}</h5>
        </div>

        <div class="col-sm-12">
            <slot name="extra"></slot>
        </div>

        <slot/>

    </div>
</template>

<script>

export default {
    components: {},

    props: {
        title: {required: true},
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
